import { type CSSProperties, useEffect } from "react";

import { Button } from "@unified-checkout/design-system";
import { Check, Copy } from "@unified-checkout/design-system/icons/index";

import { useCopyToClipboard } from "../../../hooks/useCopyToClipboard";
import type { ICopyToClipboard } from "@app/dashboard/types/innerLayout/copy-to-clipboard";
import styles from "./copy-to-clipboard.module.scss";


export const CopyToClipboard = ({
  size = "md",
  withSpacings = false,
  textToCopy,
  delay = 2000,
  onCopyStateChange,
  onCopyHandler,
  elements
}: ICopyToClipboard) => {

  const { isCopied, copy } = useCopyToClipboard(delay);

  useEffect(() => {
    onCopyStateChange?.(isCopied);
  }, [isCopied]);

  const handleCopy = () => {
    copy(textToCopy);
    onCopyHandler?.();
  };

  const CopiedElement = Check;
  const ClickToCopyElement = <Button
    size={size}
    variant="link"
    leadingIcon={elements?.clickToCopy?.icon || Copy}
  />;


  return (
    <div
      className={styles['copy-to-clipboard']}
      data-ctc-with-spacings={withSpacings}
      data-ctc-size={size}
      data-ctc-fill-or-stroke={elements?.clickToCopy?.fillOrStrokeColor}
      style={elements?.clickToCopy?.color ? { '--ctc-color': elements.clickToCopy.color } as CSSProperties : undefined}
    >
      {
        isCopied ?
          <div className={styles['copy-to-clipboard__copied']}>
            {elements?.copied || CopiedElement}
          </div>
          :
          <div
            className={styles['copy-to-clipboard__click-to-copy']}
            onClick={handleCopy}
          >
            {elements?.clickToCopy?.element || ClickToCopyElement}
          </div>
      }
    </div>
  );
}
